import { connect } from "react-redux";
import SocialMemberBubble from "../components/SocialMemberBubble";
import { fetchAvatars } from "../actions";
var mapStateToProps = function(state, ownProps) {
    return {
        avatar: !!ownProps.member && ownProps.member.length === 1 && state.userAvatars[ownProps.member[0].foreign_id]
    };
};
var mapDispatchToProps = function(dispatch, ownProps) {
    return {
        fetch: function() {
            dispatch(fetchAvatars());
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SocialMemberBubble);
